import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { encryptTransform } from "redux-persist-transform-encrypt";
import { authSlice } from "../redux";
import config from "../config";
import { logger } from "../utils";

// Combine all reducers into a root reducer
const RootReducer = combineReducers({
  auth: authSlice,
});

// Configuration for the encryption transform
const encryptor = encryptTransform({
  secretKey: `${config.NAME_KEY}-storage`,
  onError: (error) => {
    // Log errors during encryption
    logger({ error });
  },
});

// Configuration for persisting state
const persistConfig = {
  key: config.NAME_KEY,
  storage,
  whitelist: ["auth"], // Only persist the "auth" slice of the state
  transforms: [encryptor], // Apply encryption transform to persisted data
};

// Create a persisted reducer using the root reducer and persist configuration
const persistedReducer = persistReducer(persistConfig, RootReducer);

// Configure the Redux store
const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    // Configure middleware to ignore certain actions during serialization

    // https://github.com/rt2zz/redux-persist/issues/988#issuecomment-552242978
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
  devTools: config.NODE_ENV !== "production", // Enable Redux DevTools in development
});

// Export the configured store
export default store;

// Create and export the persistor to enable persistence
export const Persistor = persistStore(store);
